export const COMPLETED = 'COMPLETED';
export const LOADING = 'LOADING';
export const UNINITIALIZED = 'UNINITIALIZED';
export const ERROR = 'ERROR';

export default (name, endpoint, role) => {
  const initialState = { status: UNINITIALIZED, data: undefined, endpoint: endpoint, role: role };

  return (state = initialState, action) => {
    switch (action.type) {
      case name + '_' + COMPLETED:
        return {
          status: COMPLETED,
          data: action.payload,
          endpoint: endpoint,
          role: role,
        };
      case name + '_' + LOADING:
        return {
          status: LOADING,
          data: undefined,
          endpoint: endpoint,
          role: role,
        };
      case name + '_' + UNINITIALIZED:
        return {
          status: UNINITIALIZED,
          data: undefined,
          endpoint: endpoint,
          role: role,
        };
      case name + '_' + ERROR:
        return {
          status: ERROR,
          data: undefined,
          endpoint: endpoint,
          role: role,
        };
      default:
        return state;
    }
  };
};
